'use client';

import { c as _c } from "react/compiler-runtime";
import type { TabItem } from '@xefi/x-react/tabs';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import { useTranslation } from 'react-i18next';
import { NotificationBadge } from '@/components/NotificationBadge';
import { LoadingTabSkeleton } from '../_components/LoadingTabSkeleton';
interface UseSurveyTabsProps {
  activeSurveysCount: number;
  closedSurveysCount: number;
  isLoadingActive: boolean;
  isLoadingClosed: boolean;
  activeTabKey?: string;
}
function buildTabCountTitle(label: string, count: number, isSelected: boolean, minWidth: string) {
  return <div className={mergeTailwindClasses(`flex ${minWidth} items-center gap-2`, isSelected && 'text-white')}>
         <span>{label}</span>
         {typeof count === 'number' && <NotificationBadge count={count} isActive={isSelected} />}
      </div>;
}
export const useSurveyTabs = t0 => {
  const $ = _c(17);
  const {
    activeSurveysCount,
    closedSurveysCount,
    isLoadingActive,
    isLoadingClosed,
    activeTabKey
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== activeSurveysCount || $[1] !== activeTabKey || $[2] !== isLoadingActive || $[3] !== t) {
    t1 = isLoadingActive ? <LoadingTabSkeleton label={t("survey.nbActive_other")} /> : buildTabCountTitle(t("survey.nbActive_other"), activeSurveysCount, activeTabKey === "active", "min-w-20");
    $[0] = activeSurveysCount;
    $[1] = activeTabKey;
    $[2] = isLoadingActive;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = {
      key: "active",
      content: "",
      title: t1
    };
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== activeTabKey || $[8] !== closedSurveysCount || $[9] !== isLoadingClosed || $[10] !== t) {
    t3 = isLoadingClosed ? <LoadingTabSkeleton label={t("survey.nbClosed_other")} /> : buildTabCountTitle(t("survey.nbClosed_other"), closedSurveysCount, activeTabKey === "closed", "min-w-24");
    $[7] = activeTabKey;
    $[8] = closedSurveysCount;
    $[9] = isLoadingClosed;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = {
      key: "closed",
      content: "",
      title: t3
    };
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = [t2, t4];
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};